import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import ReactDOM from 'react-dom';

import NewsCard from './events-card';
import SearchBox from '../search-box';
import NoResults from '../no-results';

import Api from '../../../lib/seam-api';

import CustomSelect from '../select';
import ContainerIndex from '../../../layouts/containers/container-index';
import IndexCard from '../../../components/cards/index-card';
import MediaHelper from '../../../lib/helpers/media';
import { getDSTLocalTime } from '../../../lib/helpers/datetime-helpers';

import { ButtonProceed, ButtonModify } from '../../../components/buttons';
import Row from '../../../components/row';
import List from '../../../components/list';
import { SmallPill } from '../../../components/pills';
import { fireEnquireOpenEvent } from '../../overlay/enquire';

class Events extends Component {
    constructor(props) {
        super(props);

        this.state = {
            events: [],
            types: [],

            selectedType: '',
            search: '',
            page: 1,
            pageCount: 0,
            itemOffset: 0,
            itemsPerPage: 12,
            cdnUrl : '',
            sort: null,
            eventTypeIds: [],
            order_direction: 'asc',
        }

        this.timer = null;
    }

    componentDidMount() {
        this.fetchDefault();
        this.fetchTypes();
   }

   handlePageClick = (event) => {
    this.setState({ page: event.selected + 1 }, () => this.fetchDefault());
    }

   async fetchDefault() {
        const { data, meta: { last_page, cdn_url } } = await Api.events().get({
            page: this.state.pageCount,
            perPage: this.state.itemsPerPage,
            eventTypes: this.state.eventTypeIds,
            order_direction: this.state.order_direction,
        });

        this.setState({ events: data, pageCount : last_page, cdnUrl : cdn_url });
   }

   async fetchTypes() {
        const { data } = await Api.events().types();

        this.setState({ types: data })
   }

   async search() {
        if (this.state.search.length == 0) return;

        if (this.timer) {
            clearTimeout(this.timer);
        }

        this.searchAll();
   }

   async searchTypes() {
        if (this.state.search.length == 0) return this.fetchDefault();

        this.searchAll();
   }

   async searchAll() {
    const { data } = await Api.events().search({
        page: this.state.pageCount,
        perPage: this.state.itemsPerPage,
        term: this.state.search,
        eventTypes: this.state.eventTypeIds,
        order_direction: this.state.order_direction,
    });

    this.setState({ events: data, pageCount: 0 });
   }

   typesOnChange(event) {
       this.setState({
           selectedType: Number(event.value),
       }, () => {
        this.searchTypes();
       });
   }

   onChangeHandler(e) {
        this.setState({
            search: e.target.value,
        }, () => {
            this.changed();
        });
    }

    changed() {
        if (this.state.search.length > 0) {
            return this.search();
        }

        this.fetchDefault();
    }

    getSectionImage(event) {
        if(!event.content) {
            return '';
        }

        if(event.content.hasOwnProperty('sections') === false) {
            return  '';
        }

        const si  =  _.findIndex(event.content.sections, s => {
            return s.name === 'hero';
        });

        if(si === -1) {
            return '';
        }

        const hero = event.content.sections[si];

        if(hero.hasOwnProperty('content') === false) {
            return '';
        }

        return hero.content.hasOwnProperty('background image') ?`${this.state.cdnUrl}/images/${hero.content['background image'].value}`  : '';

    }

    truncateDescription (input) {
        return input?.length > 65 ? `${input.substring(0, 65)}...` : input;
    }

    addEventType({ value }) {
        const eventTypeIds = Array.isArray(this.state.eventTypeIds) ? [ ...this.state.eventTypeIds ] : []

        if (eventTypeIds.includes(value)) return;

        eventTypeIds.push(value);

        this.setState({ eventTypeIds }, () => this.fetchDefault());
    }

    deleteEventType(id) {
        let eventTypeIds = Array.isArray(this.state.eventTypeIds) ? [ ...this.state.eventTypeIds ] : []

        eventTypeIds = eventTypeIds.filter((val) => val !== id);

        this.setState({ eventTypeIds }, () => this.fetchDefault());
    }

    onSortChange() {

    }

    onOrderDirectionChange(e) {
        this.setState({ order_direction: e.target.value })
    }

    render () {
        return (
            <ContainerIndex>
                <ContainerIndex.Filters>
                    <List gap="20px" style={{ width: '100%' }}>
                        <SearchBox search={this.state.search} onChangeHandler={this.onChangeHandler.bind(this)}/>
                        <Row gap="20px">
                            <CustomSelect
                                placeholder="Order Direction"
                                value={this.state.order_direction}
                                onChange={this.onOrderDirectionChange.bind(this)}
                                items={[
                                    {
                                        option: 'Ascending',
                                        value: 'asc'
                                    },
                                    {
                                        option: 'Descending',
                                        value: 'desc'
                                    },
                                ]}
                            />
                            <CustomSelect
                                label="Event Types"
                                items={
                                    this.state.types?.map((type) => {
                                        return {
                                            option: type?.name,
                                            value: type?.id
                                        }
                                    })
                                }
                                onChange={this.addEventType.bind(this)}
                            />
                        </Row>

                        <Row gap="10px" wrap>
                            { this.state.eventTypeIds?.map((type, index) => {
                                const eventType = this.state.types.find(t => t.id === type);

                                return <SmallPill key={index} removable={true} onRemoveClick={() => this.deleteEventType(type)}>{ eventType?.name }</SmallPill>
                            }) }
                        </Row>
                    </List>
                </ContainerIndex.Filters>

                {  this.state.events?.length > 0 && 
                    <ContainerIndex.Content className='columns-3'>
                        { this.state.events.map(event => {

                            return (
                                <IndexCard
                                    image={event?.content?.feature_image?.[0]?.file_name ? MediaHelper.formatPublicPath(`/images/${event?.content?.feature_image?.[0]?.file_name}`) : '/images/office.png'}
                                    title={event?.name}
                                    subtitle={event?.description}
                                    infos={[
                                        {
                                            label : 'DATE',
                                            value : getDSTLocalTime(event?.start).format('DD/MM/YYYY')
                                        },
                                        {
                                            label : 'TIME',
                                            value : getDSTLocalTime(event?.start).format('HH:mm')
                                        }
                                    ]}
                                    buttons={
                                        <>
                                            <ButtonProceed onClick={() => window.location.href = `/events/${event.slug}`}>Overview</ButtonProceed>
                                            <ButtonModify onClick={() => window.location.href = `/events/${event.slug}/book`}>Book</ButtonModify>
                                        </>
                                    }/>
                            )
                        }) }
                    </ContainerIndex.Content>
                }

                { this.state.events?.length === 0 && 
                    <NoResults
                        title={'NO EVENTS FOUND'}
                        subtitle={'Please can you refine your result or try searching manually.'}
                        content={`Need help finding what you're looking for?`}
                        onClick={e => {
                            e.preventDefault();
                            fireEnquireOpenEvent(0)
                        }}
                    />
                }

                <ReactPaginate
                    breakLabel="..."
                    onPageChange={this.handlePageClick.bind(this)}
                    pageRangeDisplayed={5}
                    pageCount={this.state.pageCount}
                    nextLabel={<img src='/images/blocks/gallery/arrow.svg' alt='Next Arrow'/>}
                    previousLabel={<img src='/images/blocks/gallery/arrow.svg' alt='Previous Arrow'/>}
                    renderOnZeroPageCount={null}
                    containerClassName="event-index__pagination"
                />
            </ContainerIndex>
        )
    }
}

export default Events;

document.addEventListener('readystatechange', () => {
    const element = document.getElementById('events-index')

    if (element) {
        ReactDOM.render(<Events/>, element);
    }
});
